import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const UnauthenticatedPageContentLayout = ({ className, title, subtitle, children }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.panel}>
        {title && (
          <CustomTypography
            className={styles.title}
            variant="h4"
          >
            {title}
          </CustomTypography>
        )}
        {subtitle && (
          <CustomTypography
            className={styles.subtitle}
            variant={TYPOGRAPHY_VARIANT.paragraph16}
            dangerouslySetInnerHTML={{
              __html: subtitle,
            }}
          />
        )}
        {children}
      </div>
    </div>
  );
};
UnauthenticatedPageContentLayout.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
};

UnauthenticatedPageContentLayout.defaultProps = {
  className: null,
  title: null,
  subtitle: null,
  children: null,
};
